import React, {useEffect} from 'react';


import {useDispatch, useSelector} from 'react-redux';
import {actions} from '../../../redux/actions';
import userImg from '../../../assets/img/undraw_profile.svg';
import {getBank, getBanks, setDefaultBank, setHideAmount} from "../../../services/Bank";
import {currencyFormat} from "../../../utils/masks";
import {BiCaretDown,} from "react-icons/bi";
import {Link} from "react-router-dom";
import {Container, LogoSection} from "./styles";
import logo from '../../../assets/img/logo.png';
import {getShowModalInfo, getSignature, setShowModalInfo} from "../../../services/Profile";
import brokerTypes from "../../../constants/BrokerTypes";
import {useTranslation} from "react-i18next";

function Topbar () {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {id, hideAmount, amount, coinType, banks, broker} = useSelector(
      (state) => state.BankReducer
  );

  function logout() {
    localStorage.clear();
    window.location="/";
  }

  function changeHideAmount(hideAmount) {
    const data = new FormData();
    data.append('hideAmount', hideAmount);
    setHideAmount(data).then(() => {
      dispatch(actions.setHideAmount(hideAmount));
    });
  }

  useEffect(() => {
    getBank().then((data) => {
      dispatch(actions.updateBank(data));
    });

    getBanks().then((banks) => {
      dispatch(actions.setBanks(banks));
    });

    getSignature().then((data) => {
      if (!data) {
        return;
      }
      dispatch(actions.setActiveSignature(data.data.isSignatureActive));
      dispatch(actions.setIsEnableFreeSignature(data.data.isEnableFreeSignature));
      dispatch(actions.setIsFreeSignature(data.data.isFree));
      dispatch(actions.setAffiliateID(data.data.affiliateID));
      dispatch(actions.setId(data.data.idUser));
      dispatch(actions.setKeyPix(data.data.keyPix));
      dispatch(actions.setRoles(data.data.roles));
      dispatch(actions.setDueDateSignature(data.data.dueDate ? new Date(data.data.dueDate.date).toLocaleDateString() : null));
    });

    getShowModalInfo().then((data) => {
      if (data.data.showModalInfo) {
        dispatch(actions.setShowModalInfo(true));
        setShowModalInfo(false).then(r => {});

        /*swal(
            {
              buttons: ["Depois", "Quero ser afiliado"],
              content: <div>
                <h1 className={"font-weight-bolder h3"}>Olá, Trader! Temos uma Super Novidade! <GiPartyPopper color={"#FF6347"} size={60}/></h1>
                <br/>
                <p>
                  Agora você pode ganhar dinheiro indicando nossa plataforma!
                </p>
                <p>
                  Torne-se nosso afiliado e tenha a oportunidade de compartilhar nossa plataforma com amigos e conhecidos. Cada nova assinatura através do seu link exclusivo gera recompensas para você!
                </p>
                <p>
                  Deseja se tornar um afiliado agora?
                </p>
              </div>,
            }
        ).then((isConfirm) => {
          if (isConfirm) {
            history.push('/affiliate-program');
          }
        });*/
      }
    });
  }, []);

  function getBroker(value) {
    for (var index in brokerTypes) {
      if (brokerTypes[index].key === value) {
        return brokerTypes[index].value
      }
    }

    return null
  }

  function selectBank(bankId) {
    setDefaultBank(bankId).then((data) => {
      window.location.href = '/dashboard';
    });
  }

  return (
    <>
    <Container className="navbar navbar-expand navbar-light topbar mb-4 static-top shadow">
      <button onClick={() => { dispatch(actions.clickMenuOpen()); }}  id="sidebarToggleTop" className="btn btn-link d-md-none rounded-circle mr-2">
        <i className="fa fa-bars"/>
      </button>
      <LogoSection className="d-md-none" aria-label="GBinary">
        <Link to="/dashboard">
          <img src={logo} alt="GBinary" />
        </Link>
      </LogoSection>
      <ul className="navbar-nav ml-auto topbar-nav-actions">
        {id && <li className="nav-item dropdown no-arrow topbar-bank-item">
          <a className="nav-link dropdown-toggle topbar-bank-trigger" href="#" id="bankDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <span className="text-white small topbar-broker-wrap">
                <span className="d-none d-md-inline">{t('header_bank')}{' '}</span>
                <b>{broker ? getBroker(broker) : ''}</b>:
            </span>
            <span
                className="d-flex align-items-center justify-content-center topbar-amount"
                style={{cursor: 'pointer', color: 'rgb(10 255 25)'}}
            >
              {!hideAmount ? (
                  <span className="topbar-amount-value">{coinType} {currencyFormat(amount)}</span>
              ) : (
                  <span className="topbar-amount-value">{coinType} ******</span>
              )}
            </span>
            <span className="text-white small font-weight-bolder topbar-caret-wrap">
              <BiCaretDown className="topbar-caret-icon" size={22}/>
            </span>
          </a>
          <div className="dropdown-menu dropdown-menu-right shadow animated--grow-in" aria-labelledby="bankDropdown">
            <div className="dropdown-item font-weight-bolder">
              <span>{t('header_options')}</span>
              <hr className={"mt-1 mb-0"}/>
            </div>
            <span className="dropdown-item" onClick={() => changeHideAmount(!hideAmount)}>
              {!hideAmount ?
                  <>
                    <i className="fa fa-eye-slash fa-sm fa-fw mr-2 text-gray-400"></i>
                    {t('header_show_balance')}
                  </> :
                  <>
                    <i className="fa fa-eye fa-sm fa-fw mr-2 text-gray-400"></i>
                    {t('header_hide_balance')}
                  </>
              }
            </span>
            <Link to="/bank/new" className="dropdown-item">
              <i className="fa fa-plus fa-sm fa-fw mr-2 text-gray-400"></i>
              {t('header_add_bank')}
            </Link>
            {banks.length && <div className="dropdown-item font-weight-bolder mt-2">
              <span>{t('header_select_bank')}</span>
              <hr className={"mt-1 mb-0"}/>
            </div>}
            {banks.length && banks.map((bank, index) => (
                <span className="dropdown-item" key={index} onClick={() => {selectBank(bank.id)}}>
                {getBroker(bank.broker)}
              </span>
            ))}
          </div>
        </li>}
        <div className="topbar-divider d-none d-sm-block"></div>
        <li className="nav-item dropdown no-arrow topbar-user-item">
          <a className="nav-link dropdown-toggle topbar-user-trigger" href="#" id="userDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <span className="mr-2 d-none d-lg-inline text-white small font-weight-bold">{localStorage.getItem('@name')}</span>
            <img className="img-profile rounded-circle topbar-avatar" src={userImg} alt=""/>
          </a>
          <div className="dropdown-menu dropdown-menu-right shadow animated--grow-in" aria-labelledby="userDropdown">
            <Link to="/profile" className="dropdown-item">
              <i className="far fa-user fa-sm fa-fw mr-2 text-gray-400"></i>
              {t('header_perfil')}
            </Link>
            <div className="dropdown-divider" />
            <span className="dropdown-item" onClick={() => { logout() }}>
              <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
              {t('header_logout')}
            </span>
          </div>
        </li>
      </ul>
    </Container>
    </>
  )
}

export default Topbar;